export class PoderResponse {
    poderes:Poder[];
    participantes:any;
    
}

export class Poder{
    numeroControl:string = '';
    fechaIngreso:string = '';
    encargado:string = '';
    fechaVencimiento:string = '';
    observacion:string = '';
    
    
}